import { MessageCircle, X } from "lucide-mui"
import React from "react"

import i18n from "@/i18n"

type MobileCoachMarkProps = {
  onDismiss: () => void
}

/**
 * Mobile table-screen coach-mark (Figma 1283-10): a white card with a downward tail floating over the
 * top of the map. Chat-bubble icon in a grey circle, bold heading + grey body, and an `×` to dismiss.
 * Shown once per user — visibility/persistence is owned by `usePersistedCoachmark`.
 */
const MobileCoachMark: React.FC<MobileCoachMarkProps> = ({ onDismiss }) => (
  <div
    className="pointer-events-none absolute left-1/2 top-4 z-20 w-[calc(100%-32px)] max-w-[350px] -translate-x-1/2"
    data-testid="public-reservation-modal-mobile-coach-mark"
  >
    <div className="pointer-events-auto relative rounded-lg bg-white px-4 py-3.5 shadow-[0_8px_24px_rgba(15,23,42,0.14)]">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#f2f3f5]">
          <MessageCircle className="h-[18px] w-[18px] text-[#6c717b]" />
        </div>

        <div className="flex-1 pr-4">
          <p className="text-[12px] font-medium leading-tight text-black">
            {i18n.t("app.public.venue.table_selection.coach_title")}
          </p>
          <p className="mt-1 text-[12px] font-normal leading-snug text-[#6c717b]">
            {i18n.t("app.public.venue.table_selection.coach_body")}
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={onDismiss}
        className="absolute right-3 top-3 flex h-6 w-6 items-center justify-center text-[#6c717b]"
        aria-label={i18n.t("app.public.venue.table_selection.coach_dismiss")}
        data-testid="public-reservation-modal-mobile-coach-mark-close"
      >
        <X className="h-4 w-4" />
      </button>

      <div className="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 border-x-[9px] border-x-transparent border-t-[9px] border-t-white drop-shadow-[0_4px_3px_rgba(15,23,42,0.05)]" />
    </div>
  </div>
)

export default MobileCoachMark
